import { StructuredStorageSlots } from '../../constants';
import { KeyStructuredStorageBaseHelper } from './KeyStructuredStorageBaseHelper';
export class GetKeyStructuredStorageHelper extends KeyStructuredStorageBaseHelper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.unwrapKeyStructuredStorage({
            type: this.keyType,
            knownType: this.knownKeyType,
        }));
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.unwrapVal({ type: this.type }));
        sb.emitPushInt(node, StructuredStorageSlots.prefix);
        sb.emitOp(node, 'PICKITEM');
        sb.emitHelper(node, options, sb.helpers.arrReduce({
            each: () => {
                sb.emitOp(node, 'SWAP');
                sb.emitSysCall(node, 'Neo.Runtime.Serialize');
                sb.emitOp(node, 'CAT');
            },
        }));
    }
}

//# sourceMappingURL=GetKeyStructuredStorageHelper.js.map
